export default __webpack_public_path__ + "static/media/games-galery1.f894b615.jpg";